import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { KeyRound } from "lucide-react";
import { toast, Toaster } from "sonner";
import { adminApi, setAdminToken } from "./api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminApi.post("/admin/login", { email, password });
      setAdminToken(res.data.token);
      toast.success("Accesso effettuato");
      navigate("/admin");
    } catch (err) {
      toast.error("Credenziali non valide");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#08080A] px-6">
      <Toaster theme="dark" position="top-right" richColors />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="relative w-full max-w-md"
      >
        <div className="absolute -top-40 -right-40 h-[400px] w-[400px] rounded-full bg-[#C48F56] blur-[180px] opacity-20" />
        <div className="absolute -bottom-40 -left-40 h-[300px] w-[300px] rounded-full bg-[#70142A] blur-[140px] opacity-20" />

        <div className="relative glass-strong rounded-2xl p-10">
          <div className="h-12 w-12 rounded-full bg-white text-black grid place-items-center mx-auto">
            <KeyRound size={18} />
          </div>
          <h1 className="mt-6 font-display text-4xl text-center tracking-tight">
            Admin
          </h1>
          <p className="mt-3 text-center text-white/60 text-sm">
            Accesso riservato al team Invest Hospitality.
          </p>

          <form onSubmit={submit} className="mt-10 space-y-5">
            <div>
              <label className="block font-mono text-[10px] uppercase tracking-[0.25em] text-white/40 mb-2">
                Email
              </label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-email"
                className="w-full bg-transparent border-b border-white/15 focus:border-[#C48F56] outline-none py-3 text-base"
              />
            </div>
            <div>
              <label className="block font-mono text-[10px] uppercase tracking-[0.25em] text-white/40 mb-2">
                Password
              </label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password"
                className="w-full bg-transparent border-b border-white/15 focus:border-[#C48F56] outline-none py-3 text-base"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-submit"
              className="w-full rounded-full bg-white text-black px-6 py-3 text-sm font-medium hover:bg-[#C48F56] disabled:opacity-50 transition-colors"
            >
              {loading ? "Accesso…" : "Accedi"}
            </button>
          </form>
        </div>
      </motion.div>
    </div>
  );
}
